import React, { useState, useEffect, useRef } from "react";
import CommonInput from "./commonInput";
import CommonButton from "./commonButton";
import CommonPhoneInput from "./commonPhoneInput";
import closeIcon from "../../assests/images/icon.png";
import CheckMark from "../../assests/images/check_mark.png";
import { ProgressBar } from "primereact/progressbar";
import isEmpty from "lodash";
import CommonDropdown from "./commonDropdown";
import { useSelector } from "react-redux";
import CommonCheckbox from "./commonCheckBox";
import { useTranslation } from "react-i18next";
import CommonLoader from "./commonLoader";
import { useLoader } from "./LoaderProvider";
import { Controller } from "react-hook-form";
import Search from "../../assests/images/add button.png";
import CommonMultiSelect from "./commonDropDownMulti";
import dropdownICon from "../../assests/images/dropdownMark.png";
import { Calendar } from "primereact/calendar";
import accordionOpen from "../../assests/images/icon-accordion-open.png";
import { extractPhoneNumber, formatDate } from "../utils/commonFunction";
import { useToast } from "./Toast";
import { getAslCheck } from "../../service/action/actioncreator/HospitalAction/Hospital";
import { useDispatch } from "react-redux";

const StepperModal = ({
  isModalOpen,
  progress,
  onSubmit,
  roleBasedSteps,
  handleCloseSubmission,
  watch,
  handleModalClose,
  currentStep,
  getValues,
  errors,
  register,
  validateField,
  control,
  isSuccess,
  hospitalList,
  onCountryChange,
  onChange = () => { },
  setCurrentStep,
  stepConfigs,
  handleSubmitStep,
  setProgress,
  trigger,
  dropdownOptions,
  dropdownOptions2,
  mainTitle,
  searchTableData,
  menuRoleId,
  errorFlag,
  dropdownAll,
  pickupOptions,
  dropdownValue,
  dropDownNotification,
  setValue,
  remainderOptions,
  pharmacyOptionFn = () => { },
  consentsOptions,
  homeDeliveryOption,
  activePatientData,
  loading,
  modalActiveReg,
  isUserFlag,
  size,
  handleImageClick,
  fields,
  append,
  remove,
  removePharmacy,
  appendPharmacy,
  fieldsPharmacy,
  fieldsDropDown,
  removeField,
  appendField,
  countryDialCode,
  regionName,
  selectedData,
  pharmacyList,
  pharmacyDropdown,
  setSavedData,
  savedData,
  removeCalender,
  appendCalender,
  fieldsCalender,
  progressHide,
  hospitalfacilitiesSuccess,
  filteredDropdownTab,
  hospitalPharmacySuccess,
  hospitalRetailSuccess,
  hospitalStructureSuccess,
  aslDropdown,
  setWeekDay,
  weekDays,
  dateFormat,
  disableBtn,
  setDropdownPharamcyData,
  dropdownPharamcyData,
  calendarData,
  setCalendarData,
  calendarValue,
  setCalendarValue,
  fetchDropdownOptions,
  screen,
  pharmacyIdsData,
  setPharmacyIdsData,
  isEditOpen = false,
  profileUpdatePage = false,
  selectedValuesChip,
  setSelectedValuesChip,
  changeCallback = () => { },
  pharmacySupervisorOptionFn = () => { }
}) => {
  const { t } = useTranslation("translation");
  const { showToast } = useToast();
  const calenderRef = useRef(null);
  const dispatch = useDispatch();
  const {
    showLoader,
    hideLoader,
    loadingStepper,
    showStepperLoader,
    hideStepperLoader,
  } = useLoader();
  const [errorPassword, setErrorPassword] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [dropDownData, setDropdownData] = useState("");
  const [fieldList, setFieldList] = useState(fields || []);
  const [editableIndex, setEditableIndex] = useState(null);
  const [editableIndexDropdown, setEditableIndexDropdown] = useState(null);
  const [editableDropdown, setEditableDropdown] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [showDropdown, setShowDropdown] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const [openStates, setOpenStates] = useState({});
  const [openDropdown, setOpenDropdown] = useState({});
  // const [savedData, setSavedData] = useState([]);
  const [selectedPharmacyId, setSelectedPharmacyId] = useState([]);
  const [formattedOptionPharmacy, setFormattedOptionPharmacy] = useState([]);
  const [disabledFields, setDisabledFields] = useState({});
  const [fieldValue, setFieldValue] = useState([]);
  const [openCalender, setOpenCalender] = useState(false);
  const [editableIndexCalender, setEditableIndexCalender] = useState(null);
  const [structurePharmacy, setStructurePharmacy] = useState([]);
  const [openTabDropdown, setOpenTabDropdown] = useState(false);
  const [editdropdownVale, setEditDropdownPharamcyData] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledCalendar, setIsDisabledCalendar] = useState(true);
  const [calenderData, setCalenderData] = useState([]);

  // const [calendarValue,setCalendarValue] =useState([])
  const [success, setSuccess] = useState(false);
  const roleName = localStorage.getItem("roleName");
  const roleId = localStorage.getItem("roleId");

  const weekDayMap = {
    Lun: "Monday",
    Mar: "Tuesday",
    Mer: "Wednesday",
    Gio: "Thursday",
    Ven: "Friday",
    Sab: "Saturday",
    Dom: "Sunday",
  };

  const [fieldsCalenderValue, setFieldsCalenderValue] = useState([
    {
      startDate: null,
      endDate: null,
      times: Array(7).fill({ startTime: null, endTime: null }),
    },
  ]);
  // const [fieldsCalenderValue, setFieldsCalenderValue] = useState([
  //   {
  //     startDate: null,
  //     endDate: null,
  //     times: Array(7).fill(null).map(() => ({
  //       session: [
  //         { startTime: null, endTime: null },
  //         { startTime: null, endTime: null },
  //       ],
  //     })),
  //   },
  // ]);
  // const [dropdownPharamcyData,setDropdownPharamcyData] =useState({})

  const hospitalPharmacyDropdown = useSelector(
    (state) => state.hospitalReducer.currentUsers
  );
  const currentStepConfig = roleBasedSteps?.[currentStep] || {};
  const totalSteps = roleBasedSteps?.length;

  const progressMap = Array.from({ length: totalSteps }, (_, i) =>
    Math.round(((i + 1) / totalSteps) * 100)
  );

  useEffect(() => {
    if (fields?.length === 0) {
      append({
        field1: "",
        field2: "",
        field3: "",
      });
    }
  }, [append, fields]);

  useEffect(() => {
    if (!!roleBasedSteps?.[currentStep - 1]?.fields.length) {
      setIsDisabledCalendar(false);
    }
  }, [roleBasedSteps?.[currentStep - 1]?.fields]);

  useEffect(() => {
    if (fieldsDropDown?.length === 0) {
      appendField({
        field1: "",
      });
    }
  }, [appendField, fieldsDropDown]);

  useEffect(() => {
    setProgress(progressMap[currentStep - 1]);
  }, [currentStep, progressMap]);

  const fieldValues = getValues("ContactAll");

  var contactarray = fieldValues?.map((contactValue, index) => ({
    contactName: contactValue.field1,

    contactSurname: contactValue.field1,

    role: contactValue.field2,

    phoneNumber: contactValue.field3,
  }));

  const formatted = dropdownOptions?.map((option) => ({
    label: `${option?.regionName}`,
    value: option?.regionCode,
  }));

  const formattedoptions1 = dropdownOptions2?.map((option) => ({
    label: `${option?.name}`,
    value: option?.id,
  }));
  const aslOptions = aslDropdown?.map((option) => ({
    label: `${option?.regionName}${","} ${option?.municipality}${","} ${option?.companyName
      }`,
    value: option?.id,
  }));
  const selectedPharmacyIds = getValues("DropdownPharmacy");

  const handleRemain = async () => {
    setIsNextClicked(true);
    const { fields } = roleBasedSteps?.[currentStep - 1];
    const fieldNames = fields
      ?.filter((field) => field?.validation)
      ?.map((field) => field?.name);
    const isStepValid = await trigger(fieldNames);

    if (!isStepValid) {
      return;
    }
    if (menuRoleId?.[0] !== 3 && menuRoleId?.[0] !== 8 && menuRoleId?.[0] !== 9 && getValues("asldropdown") && dropdownOptions?.length === 0) {
      showToast("warn", "Warning", "Non c'è altra farmacia collegata a questa asl scegline un'altra");
      return
    }

    setIsNextClicked(false);
    if (currentStep < Object.keys(roleBasedSteps)?.length) {
      setCurrentStep(currentStep + 1);

    } else if (currentStep < Object.keys(roleBasedSteps)?.length) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSubmitStep();
      // handleModalClose();
    }
  };

  const handleNext = async () => {
    const Name = getValues("Denominazione");
    const asl = getValues("asl");
    let payload = { Name, asl };
    if (screen === "HospitalStructure") {
      payload = { ...payload, type: null };
    } else if (screen === "HospitalPharmacy") {
      payload = { ...payload, type: "Hospital" };
    } else if (screen === "HospitalRetail") {
      payload = { ...payload, type: "Retail" };
    }

    dispatch(
      getAslCheck(
        payload,
        showLoader,
        hideLoader,
        showToast,
        t,
        setSuccess,
        handleRemain
      )
    );
  };

  const formattedOptions = dropdownOptions?.map((option) => ({
    label:
      menuRoleId?.[0] === 9
        ? `${option?.cap} - ${option?.name}${option?.city?.length > 0 ? ` - ${option?.city}` : ""}`
        : `${option?.name}${option?.city?.length > 0 ? ` - ${option?.city}` : ""}`,
    value: option?.id,
  }));

  useEffect(() => {
    let dataValue = dropdownOptions
      ?.map((obj) => {
        if (obj.id == getValues("hospitalPharamacyName")) {
          return `${obj.name} - ${obj.city}`;
        }
      })
      .filter((obj) => obj !== undefined);
    setDropdownData(dataValue);
  }, [getValues("hospitalPharamacyName")]);


  useEffect(() => {
    if (getValues("pickupData") === "Home Delivery") {
      setValue("hospitalPharamacyName", undefined);
    } else if (getValues("pickupData") === "In Pharmacy") {
      setValue("homeDeliveryName", undefined);
    } else if (getValues("pickupData") === "Pickup") {
      setValue("homeDeliveryName", undefined);
      setValue("hospitalPharamacyName", undefined);
    }
  }, [
    getValues("pickupData"),
    getValues("homeDeliveryName"),
    getValues("hospitalPharamacyName"),
  ]);
  const handleAddField = () => {
    const newField = { id: Date.now(), field1: "", field2: "", field3: "" }; // Create a new empty field
    setFieldList([...fieldList, newField]);
  };

  const handleUpdateField = (index) => {
    const updatedFields = [...fieldList];
    updatedFields[index].isEditable = true; // Enable the field for editing
    setFieldList(updatedFields);
  };

  const handleRemoveField = (index) => {
    const updatedFields = fieldList.filter((_, idx) => idx !== index);
    setFieldList(updatedFields);
  };
  const toggleContainer = (id) => {
    setOpenStates((prev) => ({
      ...prev,
      [id]: prev[id] !== undefined ? !prev[id] : false,
    }));
  };

  const toggleContainerDropdown = (id) => {
    setOpenDropdown((prev) => ({
      ...prev,
      [id]: prev[id] !== undefined ? !prev[id] : false,
    }));
  };

  const addClick = (id) => {
    toggleContainer(id);
    setShowDropdown(!showDropdown);
  };
  //
  // const handleEditSaveClick = (idx) => {
  //   if (editableIndex === idx) {
  //     setEditableIndex(null);
  //   } else {
  //     setEditableIndex(idx);
  //   }
  // };
  // how to setvalue

  const handleEditSaveClick = (idx, fieldId, textString) => {
    if (textString === "contact-stepper") {
      const currentValues = getValues("ContactAll");

      setSavedData((prev) => {
        let newData = Array.isArray(prev) ? [...prev] : [];
        newData[idx] = currentValues[idx];
        newData = newData
          ?.filter((fd) => !!fd)
          ?.map((md) => ({
            ...md,
            isSaved: true,
            index: md?.index !== undefined ? md?.index : `${idx}`,
          }));
        return newData;
      });
      setOpenStates((prev) => ({
        ...prev,
        [fieldId]: false,
      }));
      setEditableIndex(null);
    } else if (textString === "dropdown-stepper") {
      setOpenDropdown((prev) => ({
        ...prev,
        [fieldId]: false,
      }));
      setEditableIndexDropdown(null);
      const selectedValue = getValues(`DropdownPharmacy.${idx}`);
      setPharmacyIdsData(prevState => [
        ...prevState,
        { ...selectedValue, index: idx }
      ]);
      setDropdownPharamcyData(selectedValue);
      const selectedOption = pharmacyDropdown?.find(
        (option) => option.id === selectedValue
      );
      if (selectedOption) {
        const formattedValue = `${selectedOption.name} - ${selectedOption.city}`;
        setSelectedPharmacyId((prev) => [...prev, selectedValue]);
        // setValue(`DropdownPharmacy`, formattedOptionsPharmacy?.find((obj)=>obj.value==selectedValue)?.label);
        setDisabledFields((prev) => ({ ...prev, [idx]: true }));
      }
    } else if (textString === "calender-stepper") {
      // const currentValues = getValues("calenderList");
      // setCalendarValue((prevList) => {
      //   const updatedList = [...prevList];
      //   if (!updatedList[idx]) {
      //     updatedList[idx] = { startDate: null, endDate: null };
      //   }
      //   updatedList[idx] = { ...updatedList[idx], [idx]: currentValues };

      //   return updatedList;
      // });
      // setCalendarData(prevState => [
      //   ...prevState, 
      //   { ...currentValues[idx], index: idx }
      // ]);
      const currentValues = getValues("calenderList");

      // Ensure the entry exists in state before updating
      setCalendarValue((prevList) => {
        const updatedList = [...prevList];
        if (!updatedList[idx]) {
          updatedList[idx] = { startDate: null, endDate: null };
        }
        updatedList[idx] = { ...updatedList[idx], ...currentValues[idx] };
        return updatedList;
      });


      setCalendarData((prevState) => {
        const updatedData = prevState.filter((data) => data.index !== idx);
        return [
          ...updatedData,
          { ...currentValues[idx], index: idx },
        ];
      });
      setIsDisabledCalendar(true);
      setOpenCalender((prev) => ({
        ...prev,
        [fieldId]: false,
      }));
      setEditableIndexCalender(null);
    } else if (textString == "dropdown-tab") {
      const selectedValue = getValues(`DropdownFieldsPharmacy.${idx}`);
      setPharmacyIdsData(prevState => [
        ...prevState,
        { ...selectedValue, index: idx }
      ]);
      setOpenTabDropdown((prev) => ({
        ...prev,
        [fieldId]: false,
      }));
    } else if (textString == "pharmacyCalendar") {
      // setCalenderData((prevList) => {
      //   const updatedList = [...prevList];

      //   if (updatedList[idx]) {
      //     updatedList.splice(idx, 1);
      //   } else {

      //     updatedList.push({ id: Date.now(), startDate: null, endDate: null, times: [] });
      //   }

      //   return updatedList;
      // });
      // removeCalender(idx)
      setCalenderData((prevList) => {
        const updatedList = [...prevList];
        updatedList.push({
          id: Date.now(),
          startDate: null,
          endDate: null,
          times: [],
        });

        return updatedList;
      });
      removeCalender(idx);
    }

    const selectedValue = getValues(`DropdownFieldsPharmacy.${idx}`);
    setEditDropdownPharamcyData(selectedValue);
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setProgress(progressMap[currentStep - 2]);
    }
    // setValue(`DropdownPharmacy`, formattedOptionsPharmacy?.find((obj)=>obj.value==dropdownPharamcyData)?.label);
  };
  //
  // useEffect(()=>{
  //   const selectedValue = getValues(`DropdownPharmacy`);
  //   setValue(`DropdownPharmacy`, formattedOptionsPharmacy?.find((obj)=>obj.value==selectedValue)?.label);
  // },[])

  //
  const handleCalendarChange = (e, id, field) => {
    const selectedDate = e.value;
    const calenderList = getValues("calenderList") || [];

    const startDate = calenderList[id]?.startDate || null;
    const endDate = calenderList[id]?.endDate || null;

    if (field === "startDate") {
      if (endDate && selectedDate > endDate) {
        showToast(
          "warn",
          "La data di inizio deve essere antecedente alla data di fine."
        );
        return;
      }
      setValue(`calenderList.${id}.startDate`, selectedDate);
    } else if (field === "endDate") {
      if (startDate && selectedDate < startDate) {
        showToast(
          "warn",
          "La data di fine deve essere successiva alla data di inizio."
        );
        return;
      }
      setValue(`calenderList.${id}.endDate`, selectedDate);
    }
  };

  const handleTimeChange = (e, idx, field, dayIdx) => {
    const selectedTime = e.value;
    const calenderList = getValues("calenderList") || [];

    // Get existing Start Time & End Time
    const startTime = calenderList[idx]?.times?.[dayIdx]?.startTime || null;
    const endTime = calenderList[idx]?.times?.[dayIdx]?.endTime || null;

    if (field === "startTime") {
      if (endTime && selectedTime >= endTime) {
        showToast(
          "warn",
          "La data di inizio deve essere precedente alla data di fine"
        );
        return;
      }
      setValue(`calenderList.${idx}.times.${dayIdx}.startTime`, selectedTime);
    } else if (field === "endTime") {
      if (startTime && selectedTime <= startTime) {
        showToast(
          "warn",
          "La data di fine deve essere successiva alla data di inizio."
        );
        return;
      }
      setValue(`calenderList.${idx}.times.${dayIdx}.endTime`, selectedTime);
    }
  };

  const selectedPharmacy = getValues("multiSelectPharmacy");
  const valueChip = selectedValuesChip?.map((obj) => obj.code)
  const formattedOptionsMulti = dropdownOptions?.map((option) => ({

    name: `${option?.cap} - ${option?.name} - ${option?.city}`,
    code: option?.id,
    selected: !valueChip?.includes(option.id)
  }));

  const selectedCheck = getValues("DropdownPharmacy");

  const toggleContainerCalender = (id) => {
    setOpenCalender((prev) => ({
      ...prev,
      [id]: prev[id] !== undefined ? !prev[id] : false,
    }));
  };
  const toggleContainerTabDropdown = (id) => {
    setOpenTabDropdown((prev) => ({
      ...prev,
      [id]: prev[id] !== undefined ? !prev[id] : false,
    }));
  };
  const selectedIdsData = selectedPharmacyIds?.map((item) => item.value);

  const formattedOptionsPharmacy = pharmacyDropdown?.map((option) => ({
    label: `${option?.name} - ${option?.city}`,
    value: option?.id,
    disabled: selectedIdsData?.includes(option?.id),
  }));
  const DropdownFieldsPharmacyId = getValues("DropdownFieldsPharmacy")?.map(
    (item) => item.value
  );
  const selectedIdsTab = filteredDropdownTab?.map((item) => item.id);
  const tabPharmacyOption = dropdownOptions?.map((option) => ({
    label: `${option?.name} - ${option?.city}`,
    value: option?.id,
    disabled:
      selectedIdsTab?.includes(option?.id) ||
      DropdownFieldsPharmacyId?.includes(option?.id),
  }));
  const handleRemoveData = (idx, stringText) => {
    if (stringText == "contact") {
      const filteredList = savedData.filter((obj) => obj?.index != idx);
      setSavedData(filteredList);
      remove(idx);
    } else if (stringText == "dropdown-stepper") {
      // setDropdownPharamcyData((prevData) => {
      //   const newData = [...prevData];
      //   newData.splice(idx, 1);
      //   return newData;
      // });
      setDropdownPharamcyData((prevData) => {
        if (!Array.isArray(prevData)) {
          return [];
        } else {
          return prevData.filter((_, index) => index !== idx);
        }
      });
      const filteredList = pharmacyIdsData?.filter(obj => obj?.index != idx);
      setPharmacyIdsData(filteredList);
      removeField(idx);
    } else if (stringText == "pharmacyTab") {
      setEditDropdownPharamcyData((prevData) => {
        if (!Array.isArray(prevData)) {
          return [];
        } else {
          return prevData.filter((_, index) => index !== idx);
        }
      });
      removePharmacy(idx);
    } else if (stringText == "calendar-stepper") {
      setCalendarValue((prevList) => prevList.filter((_, i) => i !== idx));
      const filteredList = calendarData.filter((obj) => obj?.index != idx);
      setCalendarData(filteredList);
      removeCalender(idx);
    }
  };
  return (
    <div
      className={`modal creator-modal-wrap modal-button ${isModalOpen ? "show" : ""
        }`}
      style={{ display: isModalOpen ? "block" : "none" }}
      id="add-field-modal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden={!isModalOpen}
      data-keyboard="false"
    >
      <div
        className={`modal-dialog ${size === "xl" ? "modal-xl" : size === "lg" ? "modal-lg" : ""
          } modal-dialog-centered rounded modal-header-bg`}
      >
        <div className="modal-content rounded custom-modal-content">
          <form onSubmit={onSubmit} className="form-grid">
            {/* Modal Header */}
            <div className="header-container d-flex justify-content-between modal-header-bg">
              <h3 className="header-title heading-modal-align">{mainTitle}</h3>
              <img
                src={closeIcon}
                onClick={handleModalClose}
                className="pointer close-button brightened-image"
                width="30px"
                height="30px"
                alt="Close"
              />
            </div>

            <div
              className={`modal-body modal-stepper-body modal-body-style ${!hospitalfacilitiesSuccess ? "modal-contact-rmv" : ""
                }`}
              style={{
                height: "60vh",
              }}
            >
              {loadingStepper && <CommonLoader loading={loading} />}

              {isSuccess != true && (
                <h6 className="text-center mt-1">
                  {roleBasedSteps?.[currentStep - 1]?.title}{" "}
                </h6>
              )}

              {isSuccess != true && (
                <h5 className="text-center mt-1 fw-bold fs-6">
                  {roleBasedSteps?.[currentStep - 1]?.titleMain}{" "}
                </h5>
              )}
              {isSuccess != true && progressHide == false && (
                <ProgressBar
                  value={progress}
                  style={{ height: "10px" }}
                  className="mt-3 ms-4"
                />
              )}
              {/* Step Content */}
              {isSuccess ? (
                <div className="text-center align-items-center mt-8">
                  <div style={{ margin: "auto", width: "50%" }}>
                    <img src={CheckMark} alt="checkmark" className="tick-img" />
                    {modalActiveReg === true ? (
                      <>
                        <div className="text-black fw-bold  fs-6 mt-2">
                          {" "}
                          {t("text_greets")}
                        </div>
                        <div className="text-black fw-bold fs-6">
                          {" "}
                          {"L’assistito è stato attivato."}
                        </div>
                      </>
                    ) : isUserFlag === true ? (
                      <>
                        <div className="lh-1 text-black fw-bold mt-2">
                          {" "}
                          {t("text_greets")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {t("text_account_success")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {t("text_acc_receive_mail")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {" "}
                          {t("text_acc_receive_address")}{" "}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {t("text_acc_instruction")}{" "}
                        </div>
                      </>
                    ) : hospitalfacilitiesSuccess === true ? (
                      <>
                        <div className="lh-1 text-black fw-bold mt-2">
                          {t("text_conatct_insert_msg")}
                        </div>
                      </>
                    ) : hospitalStructureSuccess == true ||
                      hospitalRetailSuccess == true ||
                      hospitalPharmacySuccess == true ? (
                      <>
                        <div className="lh-1 text-black fw-bold mt-2">
                          {" "}
                          {t("text_greets")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {" "}
                          {hospitalStructureSuccess == true
                            ? t("text_structure_created_msg")
                            : hospitalRetailSuccess == true
                              ? t("text_retail_created_msg")
                              : t("text_pharmacy_created_msg")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {" "}
                          {t("text_new_refrence_structure")}
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {" "}
                          {t("text_platform")}{" "}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="lh-1 text-black fw-bold mt-2">
                          {" "}
                          Ben fatto!
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          L’assistito è stato inserito.
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          Il nuovo utente riceverà un link
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          {" "}
                          per accedere all’inserimento dei
                        </div>
                        <div className="lh-1 text-black fw-bold fs-6">
                          suoi dati anagrafici e anamnestici.
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={`btn-text-align button-container ${hospitalfacilitiesSuccess === true ? "" : "mt-4"
                      }`}
                    style={
                      hospitalfacilitiesSuccess === true
                        ? { marginTop: 60 }
                        : {}
                    }
                  >
                    <CommonButton
                      label={"Chiudi"}
                      className={`btn btn-success mt-3 p-2  w-40 input-style-common text-white ${size == "xl" ? "btn-width-xl-success" : "btn-width"
                        }`}
                      type="submit"
                      variant="success"
                      onClick={handleCloseSubmission}
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex flex-column justify-content-between"
                  style={{ minHeight: "45vh" }}
                >
                  {/* Fields Section */}
                  <div className="fields-container flex-grow-1">
                    <div
                      className={`row mt-2 ${!hospitalfacilitiesSuccess ? "p-3" : ""
                        }`}
                    >
                      {roleBasedSteps?.[currentStep - 1]?.fields?.map(
                        (field, index) => (
                          <>
                            {field.type === "text" && (
                              <div
                                className={
                                  currentStep === 1 &&
                                    field.name !== "Denominazione" &&
                                    field.name === "asl" &&
                                    field.name === "City"
                                    ? "col-lg-6 col-md-6 mt-2"
                                    : field.name === "Denominazione"
                                      ? "col-lg-12 col-md-12 mt-2"
                                      : field.name === "Address"
                                        ? "col-lg-8 col-md-8 mt-2"
                                        : field.name === "Province"
                                          ? "col-lg-4 col-md-4 mt-2"
                                          : field.name === "asl" ||
                                            field.name === "ministerialId" ||
                                            field.name === "City"
                                            ? "col-lg-4 col-xl-4 col-md-4 mt-2"
                                            : field.name === "vat"
                                              ? "col-lg-4 col-xl-4 col-md-4 mt-2"
                                              : hospitalfacilitiesSuccess
                                                ? "col-lg-6"
                                                : "col-lg-6 mt-4"
                                }
                                key={index}
                              >
                                <CommonInput
                                  //  name={`Name.${index}.field`}
                                  name={field.name}
                                  label={field.label}
                                  placeholder={field.placeholder}
                                  register={register}
                                  errors={errors}
                                  validationFn={validateField}
                                  inputStyle={true}
                                  errorStyle={false}
                                  errorFlag={field.validation}
                                  isNextClicked={isNextClicked}
                                  disabled={field?.disabled}
                                  maxLength={field?.maxLength ? true : false}
                                />
                              </div>
                            )}

                            {field.type === "checkbox" && (
                              <div
                                className={
                                  field?.name === "remainderMsg"
                                    ? "col-lg-6 col-md-6 mt-1"
                                    : "col-lg-12 col-md-12 mt-4"
                                }
                                key={index}
                              >
                                <CommonCheckbox
                                  register={register}
                                  control={control}
                                  options={
                                    field?.name === "remainderMsg"
                                      ? remainderOptions
                                      : field?.name === "consent"
                                        ? consentsOptions
                                        : "No data Available"
                                  }
                                  name={field.name}
                                  getValues={getValues}
                                  setValue={setValue}
                                  isMultiple={true}
                                  checkboxStyle={true}
                                />
                              </div>
                            )}
                            {field.type === "phoneNumber" && (
                              <div
                                className={
                                  field.name !== "HospitalNumber"
                                    ? "col-lg-4 col-md-4 col-xl-4"
                                    : "col-lg-6 mt-2 mt-2 ml-2"
                                }
                              >
                                {/* added mt -4 for other check working finr */}
                                <CommonPhoneInput
                                  name={field.name}
                                  placeholder={field.placeholder}
                                  control={control}
                                  errors={errors}
                                  register={register}
                                  validationFn={validateField}
                                  requiredField={true}
                                  errorStyle={false}
                                  onChange={onChange}
                                  onCountryChange={onCountryChange}
                                  errorFlag={field.validation}
                                  isNextClicked={isNextClicked}
                                  disabled={field?.disabled}
                                  changeCallback={changeCallback}
                                // phoneErrors={phoneErrors}
                                // setPhoneErrors={setPhoneErrors}
                                />
                              </div>
                            )}

                            {field.type === "dropdown" &&
                              field.name !== "Region" && (
                                <>
                                  <div
                                    className={
                                      field.name === "pickupData" ||
                                        field.name === "notificationMsg"
                                        ? "col-lg-6 col-xl-6 col-md-6 mt-2"
                                        : field.name === "Religion"
                                          ? "col-lg-4 col-xl-4 col-md-4 mt-2"
                                          : field.name === "asldropdown"
                                            ? "col-lg-12 col-xl-12 col-md-12 mt-3"
                                            : field.name === "asl"
                                              ? "col-lg-4 col-xl-4 col-md-4 mt-2"
                                              : "col-lg-12 col-xl-12 col-md-12 mt-2"
                                    }
                                  >
                                    {field.disabled === true ? (
                                      <div
                                        className=""
                                        style={{
                                          backgroundColor: "#F5FBFE",
                                          width: "100%",
                                          height: 50,
                                          display: "flex",
                                          gap: 10,
                                          justifyContent: "center",
                                          alignItems: "center",
                                          padding: 15,
                                          borderRadius: 50,
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {selectedData?.pharmacy?.length > 0
                                          ? selectedData?.pharmacy?.map(
                                            (ele) => {
                                              return (
                                                <div
                                                  className=""
                                                  style={{
                                                    padding: 5,
                                                    borderRadius: 5,
                                                  }}
                                                >
                                                  {ele.pharmacyName}
                                                </div>
                                              );
                                            }
                                          )
                                          : selectedData?.hospital?.length > 0
                                            ? selectedData?.hospital?.map(
                                              (ele) => {
                                                return (
                                                  <div
                                                    className=""
                                                    style={{
                                                      padding: 5,
                                                      borderRadius: 5,
                                                    }}
                                                  >
                                                    {ele.name}
                                                  </div>
                                                );
                                              }
                                            )
                                            : aslOptions?.find(
                                              (obj) =>
                                                obj.value ===
                                                selectedData?.aslId
                                            )?.label}
                                      </div>
                                    ) : (
                                      <CommonDropdown
                                        name={field.name}
                                        options={
                                          field.name === "pickupData"
                                            ? dropdownValue
                                            : field.name === "notificationMsg"
                                              ? dropDownNotification
                                              : field.name === "Religion"
                                                ? formatted
                                                : field.name === "pharmacy"
                                                  ? tabPharmacyOption
                                                  : field.name === "asl" ||
                                                    field.name === "asldropdown"
                                                    ? aslOptions
                                                    : formattedOptions || [
                                                      "No data available",
                                                    ]
                                        }
                                        // options={ ["No data available"]}
                                        control={control}
                                        errors={errors}
                                        register={register}
                                        pharmacyOptionFn={pharmacyOptionFn}
                                        validationFn={validateField}
                                        placeholder={field.placeholder || ""}
                                        errorStyle={false}
                                        formatOptions={field?.formatOptions}
                                        className={`parent-dropdown ${getValues("pickupData") ===
                                          "In Pharmacy" ||
                                          getValues("pickupData") ===
                                          "Home Delivery" ||
                                          getValues("pickupData") === "Pickup"
                                          ? "active-dropdown"
                                          : ""
                                          }`}
                                        defaultValue={
                                          field.name === "pickupData"
                                            ? "Pickup"
                                            : field.name === "notificationMsg"
                                              ? "SMS"
                                              : ""
                                        }
                                        disableArrowIcon={
                                          field.disableArrowIcon
                                        }
                                        disabled={roleId == 2 && menuRoleId?.[0] == 9 && field.name === "hospitalPharamacyName" ?
                                          (!getValues("asldropdown") || typeof getValues("asldropdown") == "string") : false}
                                      />
                                    )}
                                  </div>
                                  {field.name === "pickupData" &&
                                    getValues("pickupData") ===
                                    "In Pharmacy" && (
                                      <div className="col-lg-12 col-xl-12 col-md-12 mt-4">
                                        <CommonDropdown
                                          name="hospitalPharamacyName"
                                          options={
                                            formattedOptions || [
                                              "No data available",
                                            ]
                                          }
                                          control={control}
                                          errors={errors}
                                          register={register}
                                          validationFn={validateField}
                                          placeholder={"Farmacia di consgna"}
                                          className="child-dropdown"
                                          // style={{ zIndex: 1050 }}
                                          errorStyle={false}
                                          formatOptions={true}
                                        />
                                      </div>
                                    )}

                                  {field.name === "pickupData" &&
                                    getValues("pickupData") ===
                                    "Home Delivery" && (
                                      <>
                                        <p
                                          className={
                                            "mt-5 text-dark font-align-weight ms-2 fs-6"
                                          }
                                        >
                                          {"Indirizzo di consegna"}
                                        </p>

                                        <div className="col-lg-12 col-xl-12 col-md-12 mt-1">
                                          {/* <CommonDropdown
                                            name="homeDeliveryName"
                                            options={
                                              homeDeliveryOption || [
                                                "No data available",
                                              ]
                                            }
                                            control={control}
                                            errors={errors}
                                            register={register}
                                            validationFn={validateField}
                                            placeholder={
                                              "Inserisci indirizzo..."
                                            }
                                            style={{ zIndex: 1050 }}
                                            className="child-dropdown"
                                            errorStyle={false}
                                            formatOptions={true}
                                            disabled={field.disabled}
                                          /> */}
                                          <CommonInput
                                            name={'homeDeliveryName'}
                                            placeholder={'Inserisci indirizzo...'}
                                            register={register}
                                            errors={errors}
                                            validationFn={validateField}
                                            inputStyle={true}
                                            errorStyle={false}
                                            errorFlag={field.validation}
                                            isNextClicked={isNextClicked}
                                            style={{ zIndex: 1050 }}
                                            disabled={field?.disabled}
                                            maxLength={field?.maxLength ? true : false}
                                          />
                                        </div>
                                      </>
                                    )}
                                </>
                              )}
                            {field.name === "Region" &&
                              field.type == "dropdown" && (
                                <div className="col-lg-4 col-xl-4 col-md-4 mt-2">
                                  <CommonDropdown
                                    name={field.name}
                                    options={
                                      field.name === "Region" ? formatted : []
                                    }
                                    control={control}
                                    errors={errors}
                                    register={register}
                                    validationFn={validateField}
                                    placeholder={field.placeholder}
                                    className="child-dropdown"
                                    errorStyle={false}
                                    formatOptions={true}
                                    onFocus={fetchDropdownOptions}
                                    disabled={field.disabled}
                                  // onClick={fetchDropdownOptions}
                                  />
                                </div>
                              )}
                            {field.type === "multiDropdownPharmacy" &&
                              (field.disabled !== true ? (
                                <div
                                  className={"col-lg-12 col-md-12 mt-2 ml-2"}
                                >
                                  <CommonMultiSelect
                                    name={field.name}
                                    options={formattedOptionsMulti}
                                    control={control}
                                    errors={errors}
                                    register={register}
                                    validationFn={validateField}
                                    selectedValuesChip={selectedValuesChip}
                                    setSelectedValuesChip={setSelectedValuesChip}
                                    disabled={typeof getValues("asldropdown") == "string" || !getValues("asldropdown")}

                                  // formatOptions={field?.formatOptions}
                                  // maxSelectedLabels={3}
                                  />
                                  {/**/}
                                </div>
                              ) : (
                                <>
                                  <div
                                    className=""
                                    style={{
                                      backgroundColor: "#F5FBFE",
                                      width: "100%",
                                      height: 50,
                                      display: "flex",
                                      gap: 10,
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: 15,
                                      borderRadius: 10,
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {selectedData?.pharmacy &&
                                      selectedData.pharmacy.length > 0 &&
                                      selectedData?.pharmacy?.map((ele) => {
                                        return (
                                          <div
                                            className=""
                                            style={{
                                              padding: 5,
                                              borderRadius: 5,
                                            }}
                                          >
                                            {ele.pharmacyName}
                                          </div>
                                        );
                                      })}
                                  </div>
                                </>
                              ))}
                            {field.type === "summary" && (
                              <>
                                <div className="row mt-3">
                                  {!!getValues("FirstName")?.length &&
                                    !!getValues("LastName")?.length && (
                                      <div className="col-lg-6 col-xl-6">
                                        <p className="secondary-text-color fs-6 fw-bold ms-2 me-2">
                                          NOME E COGNOME
                                        </p>
                                        <p className="text-dark font-size-ls  ms-2 me-2 ">{`${getValues(
                                          "FirstName"
                                        )} ${getValues("LastName")}`}</p>
                                      </div>
                                    )}
                                  <div className="col-lg-6 col-xl-6 col-md-6">
                                    <p className="secondary-text-color fs-6 fw-bold  ms-2 me-2">
                                      CODICE FISCALE
                                    </p>
                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {getValues("FiscalCode")?.length > 0
                                        ? getValues("FiscalCode") :
                                        getValues("fiscalCode")?.length > 0 ?
                                          getValues("fiscalCode")
                                          : ""}

                                    </p>
                                  </div>
                                  {/* )} */}

                                  {field?.stringText === "telefonico" && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-5 fw-bold  ms-2 me-2">
                                        TELEFONO
                                      </p>
                                      <span className="text-dark fs-6 ms-2 me-2">
                                        {activePatientData?.phone}
                                      </span>
                                    </div>
                                  )}
                                  {!!getValues("PhoneNumber")?.length && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-5 fw-bold  ms-2 me-2">
                                        CONTATTO
                                      </p>
                                      <p className="text-dark font-size-ls ms-2 me-2">
                                        {profileUpdatePage === true ?
                                          `  ${extractPhoneNumber(countryDialCode, getValues("PhoneNumber"))}`
                                          :
                                          !isEditOpen ?
                                            ` ${extractPhoneNumber(countryDialCode, getValues("PhoneNumber"))}`
                                            :
                                            //  selectedData?.phoneNumber
                                            `
                                        ${extractPhoneNumber(countryDialCode, getValues("PhoneNumber"))}
                                      `
                                          // getValues("PhoneNumber")
                                        }
                                        {/* {`+${
                                          countryDialCode
                                        } ${getValues("PhoneNumber")?.slice(
                                          countryDialCode?.length
                                        )}`} */}

                                      </p>
                                    </div>
                                  )}
                                  {!!getValues("UserEmail")?.length && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-5 fw-bold  ms-2 me-2">
                                        {field?.stringText === "telefonico"
                                          ? "EMAIL"
                                          : "ACCOUNT"}
                                      </p>
                                      <p className="text-dark font-size-ls  ms-2 me-2 underline"
                                        style={{
                                          textWrap: 'wrap',
                                          display: 'flex',
                                          wordBreak: "break-all"
                                        }}
                                      >
                                        {getValues("UserEmail")}
                                      </p>
                                      {field?.stringText !== "telefonico" && (
                                        <p className="text-dark font-size-ls  ms-2 me-2">
                                          {"*********"}
                                        </p>
                                      )}
                                    </div>
                                  )}

                                  {getValues("hospitalAdministratorName") && field?.stringText !== "telefonico" && selectedData?.roleId != 3 && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        FARMACIA
                                      </p>
                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {dropdownAll?.[0]}
                                      </p>
                                    </div>
                                  )}


                                  {/* ( getValues("hospitalPharamacyName")?.length ?? 0 ) > 0 */}
                                  {selectedPharmacy?.length != 0 && selectedPharmacy !== undefined && selectedData?.roleId !== 3 && selectedData?.roleId !== 8 && menuRoleId != 8 && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        FARMACIA
                                      </p>

                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {formattedOptionsMulti
                                          ?.filter((obj) =>
                                            selectedPharmacy?.includes(
                                              obj?.code
                                            )
                                          )
                                          ?.map((item, index) => (
                                            <p
                                              key={index}
                                              className="text-dark font-size-ls"
                                            >
                                              {`${item?.name} `}
                                            </p>
                                          ))}
                                      </p>
                                    </div>
                                  )}
                                  {(selectedData?.roleId == 8 || menuRoleId?.[0] === 8) && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        FARMACIA
                                      </p>

                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {selectedValuesChip?.map((item, index) => (
                                          <p
                                            key={index}
                                            className="text-dark font-size-ls"
                                          >
                                            {`${item?.name} `}
                                          </p>
                                        ))}
                                      </p>
                                    </div>
                                  )
                                  }


                                  {
                                    // (roleName !== "ROLE_QC_OPERATOR" || roleName !== "ROLE_QC_ADMINISTRATOR" || roleName !== "Super Admin")
                                    (!(roleId == 7 || roleId == 1 || roleId == 2 || roleId == 8 || roleId == 9) && profileUpdatePage)
                                    && getValues("asldropdown") && (
                                      <div className="col-lg-6 col-xl-6 col-md-6">
                                        <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                          ASL RIFERIMENTO
                                        </p>
                                        <p className="text-dark font-size-ls  ms-2 me-2">
                                          {
                                            aslOptions?.find(
                                              (obj) =>
                                                obj.value ==
                                                getValues("asldropdown") ||
                                                obj.label ==
                                                getValues("asldropdown")
                                            )?.label
                                          }
                                        </p>
                                      </div>
                                    )}

                                  {(roleId !== '3' && roleId !== '5') && (menuRoleId?.[0] != 7 || menuRoleId?.[0] != 8 || menuRoleId?.[0] != 9) && !profileUpdatePage
                                    && getValues("asldropdown") && (
                                      <div className="col-lg-6 col-xl-6 col-md-6">
                                        <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                          ASL RIFERIMENTO
                                        </p>
                                        <p className="text-dark font-size-ls  ms-2 me-2">
                                          {
                                            aslOptions?.find(
                                              (obj) =>
                                                obj.value ==
                                                getValues("asldropdown") ||
                                                obj.label ==
                                                getValues("asldropdown")
                                            )?.label
                                          }
                                        </p>
                                      </div>
                                    )
                                  }



                                  {/* here asl is used again for roleid is 2 also can able to access the user sub menuroleid based */}
                                  {/* {!(menuRoleId?.[0] == 7 || menuRoleId?.[0] == 8  || menuRoleId?.[0] == 9 && !profileUpdatePage) */}

                                  {/* //Changes */}
                                  {getValues("hospitalPharamacyName") && field?.stringText !== "telefonico" && selectedData?.roleId !== 3 && selectedData?.roleId !== 8 && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        FARMACIA
                                      </p>
                                      <p className="text-dark fs-6  ms-2 me-2">
                                        {dropDownData && dropDownData?.[0]}
                                      </p>
                                    </div>
                                  )}
                                  {field?.stringText !== "userSummary" && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        {
                                          field?.stringText === "telefonico" &&
                                          field?.stringText !==
                                          "userSummary" &&
                                          getValues("pickupData") !==
                                          "Pickup" &&
                                          getValues("pickupData") !==
                                          "Home Delivery" &&
                                          "RITRIO IN FARMACIA"
                                          // : "FARMACIA"
                                        }
                                      </p>

                                      <p className="text-dark fs-6  ms-2 me-2">
                                        {dropDownData && dropDownData?.[0]}
                                      </p>
                                    </div>
                                  )}
                                  <div className="col-lg-12 col-xl-12 col-md-12">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      {getValues("pickupData") === "Pickup" &&
                                        "RITRIO"}
                                      {getValues("pickupData") ===
                                        "Home Delivery" &&
                                        "CONSEGNA A DOMICILIO"}
                                    </p>
                                    <p className="text-dark fs-6  ms-2 me-2">
                                      {getValues("pickupData") === "Pickup"
                                        ? "Pickup"
                                        : ""}
                                      {getValues("homeDeliveryName")}
                                    </p>
                                  </div>
                                  {/* )} */}
                                  {getValues("notificationMsg") && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        RICEZIONE NOTIFICHE
                                      </p>
                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {getValues("notificationMsg")}
                                      </p>
                                    </div>
                                  )}
                                  {getValues("remainderMsg") && (
                                    <div className="col-lg-6 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        RICEZIONE REMAINDER
                                      </p>
                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {getValues("remainderMsg")?.map(
                                          (obj, index, array) => (
                                            <span
                                              key={index}
                                              className="text-dark font-size-ls"
                                            >
                                              {obj}
                                              {index < array.length - 1 && ", "}
                                            </span>
                                          )
                                        )}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                            {field.type === "summaryText" && (
                              <>
                                <div className="row">
                                  {field?.stringText ===
                                    "CODICE ASSISITITO" && (
                                      <div className="col-lg-12 col-xl-12 col-md-12">
                                        <div className="text-dark fs-6  ms-2 me-2">
                                          {/* {"HCZ1234-56"} */}
                                          {activePatientData?.code}
                                        </div>
                                      </div>
                                    )}
                                  {field?.stringText === "telefonico" && (
                                    <div className="col-lg-12 col-xl-12 col-md-12">
                                      <span className="text-dark fs-6  ms-2 me-2">
                                        {/* +{activePatientData?.countryId}{" "} */}
                                        {activePatientData?.phone}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                            {/*  */}
                            {field.type === "hospitalsummary" && (
                              <>
                                <div className="row mt-3">
                                  <div className="col-lg-4 col-xl-3 col-md-4">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      DENOMINAZIONE
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {getValues("Denominazione")}
                                    </p>
                                  </div>

                                  {getValues("ministerialId")?.length > 0 && (
                                    <div className="col-lg-3 col-lg-2 col-md-3">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        ID MINISTERIABLE
                                      </p>

                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {getValues("ministerialId")}
                                      </p>
                                    </div>
                                  )}
                                  {/* {getValues("asl")?.length > 0 && (
                                    <div className="col-lg-3 col-xl-3 col-md-3">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        ASL RIFERIMENTO
                                      </p>

                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                       
                                        {
                                          aslDropdown?.find(
                                            (obj) =>
                                              obj.id == getValues("asl")
                                          )?.companyName
                                        }
 

                                      </p>
                                    </div>
               )} */}
                                  {getValues("asl")?.toString()?.length > 0 && (
                                    <div className="col-lg-3 col-xl-3 col-md-3">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold ms-2 me-2">
                                        ASL RIFERIMENTO
                                      </p>
                                      <p className="text-dark font-size-ls ms-2 me-2">
                                        {
                                          aslDropdown?.find(
                                            (obj) => obj.id === getValues("asl")
                                          )?.companyName
                                        }
                                      </p>
                                    </div>
                                  )}

                                  <div className="col-lg-3 col-xl-3 col-md-3">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      TELEFONO
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      +{countryDialCode}{" "}
                                      {getValues("HospitalNumber")?.slice(
                                        countryDialCode.length
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  {/* <div className="col-lg-2 col-xl-2 col-md-2"></div> */}

                                  <div className="col-lg-4 col-xl-3 col-md-4">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      INDIRIZZO
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {getValues("Address")}
                                    </p>
                                  </div>

                                  <div className="col-lg-3 col-lg-2 col-md-3">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      REGIONE
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {regionName?.[0]}
                                    </p>
                                  </div>

                                  <div className="col-lg-3 col-xl-3 col-md-3">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      PROVINCIA
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {getValues("Province")}
                                    </p>
                                  </div>

                                  <div className="col-lg-2 col-xl-2 col-md-2">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      COMUNE
                                    </p>

                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {"Roma"}
                                    </p>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  {/* <div className="col-lg-2 col-xl-2 col-md-2"></div> */}
                                  {selectedCheck?.length > 0 && (
                                    <div className="col-lg-4 col-xl-3 col-md-4">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        FARMACIE DI RIFERIMENTO
                                      </p>

                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {pharmacyDropdown
                                          ?.filter((obj) =>
                                            pharmacyIdsData?.some(
                                              (selected) =>
                                                selected?.value == obj?.id
                                            )
                                          )
                                          ?.map((item, index) => (
                                            <p
                                              key={index}
                                              className="text-dark font-size-ls"
                                            >
                                              {`${item?.name || ""} - ${item?.city || ""
                                                }`}
                                            </p>
                                          ))}
                                      </p>
                                    </div>
                                  )}
                                  {getValues("calenderList")?.length > 0 && (
                                    <div className="col-lg-7 col-xl-6 col-md-6">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        CALENDARI E ORARI SERVIZIO
                                      </p>
                                      <p>
                                        <div style={{ width: "auto" }}>
                                          {" "}
                                          {calendarData
                                            ?.filter(
                                              (item) =>
                                                item !== null &&
                                                Object.values(item).every(
                                                  (value) =>
                                                    value !== null &&
                                                    value !== undefined
                                                )
                                            )
                                            ?.map((obj) => {
                                              return (
                                                <p className="secondary-text-color fs-6 mt-3 ms-2 me-2">{`Valido dal ${formatDate(
                                                  obj.startDate
                                                )} al ${formatDate(
                                                  obj.endDate
                                                )}`}</p>
                                              );
                                            })}
                                        </div>
                                      </p>
                                    </div>
                                  )}

                                  <div className="col-lg-4 col-lg-4 col-md-4">
                                    <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                      CONTATTTI DI RIFERIMENTO
                                    </p>
                                    <p className="text-dark font-size-ls  ms-2 me-2">
                                      {savedData?.map((item, index) => (
                                        <div key={index} className="d-flex">
                                          <span className="field">
                                            {item.field1 + "  " + item.field2}{" "}
                                          </span>

                                          <span className="field3 ms-5">
                                            {item.field3}
                                          </span>
                                        </div>
                                      ))}
                                    </p>
                                  </div>
                                  {getValues("vat")?.toString()?.length > 0 && (
                                    <div className="col-lg-4 col-lg-4 col-md-4">
                                      <p className="secondary-text-color fs-6 mt-3 fw-bold  ms-2 me-2">
                                        P.IVA
                                      </p>
                                      <p className="text-dark font-size-ls  ms-2 me-2">
                                        {getValues("vat")}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                            {field.type === "textStep2" &&
                              field?.removeField !== true && (
                                <div className="row mt-2">
                                  <div className="col-lg-8 ms-1">
                                    <CommonInput
                                      name={field.name}
                                      label={field.label}
                                      placeholder={field.placeholder}
                                      register={register}
                                      errors={errors}
                                      // validationFn={validateField}
                                      inputStyle={true}
                                      errorStyle={false}
                                      errorFlag={field.validation}
                                      // passwordData={getValues('UserPassword')}
                                      validationFn={({ FieldName, value }) =>
                                        validateField({
                                          FieldName,
                                          value,
                                          otherValues: getValues(),
                                        })
                                      }
                                      icon={
                                        field.name === "UserConfirmPassword" &&
                                        errors["UserConfirmPassword"]
                                      }
                                      isNextClicked={isNextClicked}
                                      disabled={field?.disabled}
                                    />
                                  </div>
                                </div>
                              )}
                            {field.type === "textStepCap" &&
                              // <div className="row mt-2">
                              <div className="col-lg-12 ms-1">
                                <CommonInput
                                  name={field.name}
                                  label={field.label}
                                  placeholder={field.placeholder}
                                  register={register}
                                  errors={errors}
                                  validationFn={validateField}
                                  inputStyle={true}
                                  errorStyle={false}
                                  errorFlag={field.validation}
                                  isNextClicked={isNextClicked}
                                  disabled={field?.disabled}
                                />
                              </div>
                              // </div>
                            }

                            {/* field?.name == "hospitalPharmacy" hospitalPharmacy */}
                            {field.type === "multiDropdown" && (
                              <div>
                                <div className="col-lg-6 col-md-6 mt-4">
                                  <CommonMultiSelect
                                    name={field.name}
                                    options={
                                      formattedOptions || ["No data available"]
                                    }
                                    control={control}
                                    errors={errors}
                                    register={register}
                                    validationFn={validateField}
                                    formatOptions={field?.formatOptions}
                                    maxSelectedLabels={3}
                                    disabled={false}
                                  />
                                </div>
                              </div>
                            )}
                            {/*  */}
                            {field.type === "heading-img" && (
                              <div className="p-2 d-flex  justify-content-between align-items-center mb-3">
                                <h4 className="me-3">{field.content}</h4>
                                {field.img && (
                                  <img
                                    src={Search}
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      append({
                                        field1: "",
                                        field2: "",
                                        field3: "",
                                        field4: "",
                                      })
                                    }
                                  />
                                )}
                              </div>
                            )}
                            {field.type === "heading-img" &&
                              fields?.map((fieldItem, idx) => {
                                const isOpen =
                                  openStates[fieldItem.id] !== undefined
                                    ? openStates[fieldItem.id]
                                    : true;
                                const isValidNumber = !(
                                  getValues("ContactAll")[
                                    `${idx}`
                                  ]?.field4?.slice(countryDialCode?.length)
                                    .length >= 10
                                );

                                const allFieldsFilled =
                                  watch(`ContactAll.${idx}.field1`) &&
                                  watch(`ContactAll.${idx}.field2`) &&
                                  watch(`ContactAll.${idx}.field3`) &&
                                  watch(`ContactAll.${idx}.field4`);

                                return (
                                  <div
                                    key={fieldItem.id}
                                    className="bg-light d-flex flex-column"
                                    style={{
                                      alignItems: "flex-start",
                                      width: "100%",
                                      marginTop: "20px",
                                      borderBottom: "2px solid #e2e3eb",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                        gap: 10,
                                        marginBottom: 10,
                                        padding: 5,
                                      }}
                                      className="input-box"
                                    >
                                      {/* {} */}
                                      <div className="">
                                        <CommonInput
                                          name={`ContactAll.${idx}.field1`}
                                          placeholder="Nome"
                                          register={register}
                                          errors={
                                            errors[`ContactAll.${idx}.field1`]
                                          }
                                          validationFn={validateField}
                                          inputStyle={true}
                                          errorStyle={false}
                                          errorFlag={fieldItem.validation}
                                          isNextClicked={isNextClicked}
                                          disabled={!isOpen}
                                          onKeyDown={(e) => {
                                            if (e.key === "Tab") return;
                                            if (
                                              !/^[A-Za-zÀ-ÿ\s]$/.test(e.key) &&
                                              e.key !== "Backspace" &&
                                              e.key !== "Delete"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}

                                        // disabled={editableIndex !== idx}
                                        />
                                      </div>

                                      <div className="">
                                        <CommonInput
                                          name={`ContactAll.${idx}.field2`}
                                          placeholder="CogNome"
                                          register={register}
                                          errors={
                                            errors[`ContactAll.${idx}.field2`]
                                          }
                                          validationFn={validateField}
                                          inputStyle={true}
                                          errorStyle={false}
                                          errorFlag={fieldItem.validation}
                                          isNextClicked={isNextClicked}
                                          disabled={!isOpen}
                                          onKeyDown={(e) => {
                                            if (e.key === "Tab") return;
                                            if (
                                              !/^[A-Za-zÀ-ÿ\s]$/.test(e.key) &&
                                              e.key !== "Backspace" &&
                                              e.key !== "Delete"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}

                                        // disabled={editableIndex !== idx}
                                        />
                                      </div>

                                      <div className="">
                                        <CommonInput
                                          name={`ContactAll.${idx}.field3`}
                                          placeholder="Ruolo"
                                          register={register}
                                          errors={
                                            errors[`ContactAll.${idx}.field3`]
                                          }
                                          validationFn={validateField}
                                          inputStyle={true}
                                          errorStyle={false}
                                          errorFlag={fieldItem.validation}
                                          isNextClicked={isNextClicked}
                                          disabled={!isOpen}
                                          onKeyDown={(e) => {
                                            if (e.key === "Tab") return;
                                            if (
                                              !/^[A-Za-zÀ-ÿ\s]$/.test(e.key) &&
                                              e.key !== "Backspace" &&
                                              e.key !== "Delete"
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}

                                        // disabled={editableIndex !== idx}
                                        />
                                      </div>

                                      <div className="">
                                        <CommonPhoneInput
                                          name={`ContactAll.${idx}.field4`}
                                          placeholder={"..."}
                                          control={control}
                                          errors={
                                            errors[`ContactAll.${idx}.field4`]
                                          }
                                          register={register}
                                          validationFn={validateField}
                                          requiredField={true}
                                          errorStyle={false}
                                          onChange={onChange}
                                          onCountryChange={onCountryChange}
                                          errorFlag={field.validation}
                                          isNextClicked={isNextClicked}
                                          disabled={!isOpen}
                                          onKeyDown={(e) => {
                                            if (e.key === "Tab") return;
                                          }}
                                          changeCallback={changeCallback}
                                        />
                                      </div>
                                      <img
                                        src={
                                          isOpen ? accordionOpen : dropdownICon
                                        }
                                        // onClick={addClick}
                                        onClick={() =>
                                          toggleContainer(fieldItem.id)
                                        }
                                        alt="dropdown-icon"
                                        width={20}
                                        height={20}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                      />
                                    </div>
                                    {isOpen && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                          width: "100%",
                                        }}
                                      >
                                        <CommonButton
                                          label={t("text_rmve")?.toUpperCase()}
                                          className={`btn btn-cancel  mb-3 input-style-common btn-cancel-style btn-padding primary-text-color ${size === "xl"
                                            ? "btn-width-contact-append"
                                            : "btn-width"
                                            } `}
                                          type="button"
                                          variant="cancel"
                                          onClick={() =>
                                            handleRemoveData(idx, "contact")
                                          }
                                        />
                                        <CommonButton
                                          label={t(
                                            "text_button_save"
                                          )?.toUpperCase()}
                                          className={`btn btn-success mb-3 input-style-common text-white btn-padding ${size === "xl"
                                            ? "btn-width-contact-append"
                                            : "btn-width"
                                            }`}
                                          disabled={
                                            !allFieldsFilled || isValidNumber
                                          }
                                          type="submit"
                                          variant="success"
                                          onClick={() =>
                                            handleEditSaveClick(
                                              idx,
                                              fieldItem.id,
                                              "contact-stepper"
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            {field.type === "heading-img-dropdown" && (
                              <div className="p-2 d-flex  justify-content-between align-items-center mb-3">
                                <h4 className="me-3">
                                  <strong>{field.content}</strong>
                                </h4>
                                {field.img && (
                                  <img
                                    src={Search}
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                    onClick={() => appendField({ value: "" })}
                                  />
                                )}
                              </div>
                            )}
                            {field.type === "heading-img-dropdown" &&
                              fieldsDropDown?.map((fieldItem, idx) => {
                                const isOpenDropdown =
                                  openDropdown[fieldItem.id] !== undefined
                                    ? openDropdown[fieldItem.id]
                                    : true;
                                const allFieldsFilled = watch(
                                  `DropdownPharmacy.${idx}.value`
                                );

                                return (
                                  <div
                                    key={fieldItem.id}
                                    className="p-2 pt-3 mb-3   bg-light "
                                    style={{
                                      borderBottom: "2px solid #e2e3eb",
                                    }}
                                  >
                                    <div
                                      className=""
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div className="col-lg-11 col-xl-11 col-md-11 ">
                                        <CommonDropdown
                                          name={`DropdownPharmacy.${idx}.value`}
                                          options={formattedOptionsPharmacy}
                                          control={control}
                                          errors={errors}
                                          register={register}
                                          validationFn={validateField}
                                          placeholder={"..."}
                                          style={{ zIndex: 1050 }}
                                          className="child-dropdown"
                                          errorStyle={false}
                                          formatOptions={true}
                                          disabled={!isOpenDropdown}
                                        // defaultValue={getValues('DropdownPharmacy')}
                                        />
                                      </div>
                                      <div
                                        className="col-lg-1 col-xl-1 col-md-1 "
                                        style={{
                                          justifyContent: "center",
                                          display: "flex",
                                        }}
                                      >
                                        <img
                                          src={
                                            isOpenDropdown
                                              ? accordionOpen
                                              : dropdownICon
                                          }
                                          onClick={() =>
                                            toggleContainerDropdown(
                                              fieldItem.id
                                            )
                                          }
                                          alt="dropdown-icon"
                                        />
                                      </div>
                                    </div>
                                    {isOpenDropdown && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                          width: "100%",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <CommonButton
                                          label={"ELIMINA"}
                                          className={`btn btn-cancel mt-3 input-style-common btn-cancel-style btn-padding primary-text-color ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="button"
                                          variant="cancel"
                                          onClick={() =>
                                            handleRemoveData(
                                              idx,
                                              "dropdown-stepper"
                                            )
                                          }
                                        />

                                        <CommonButton
                                          label={"SALVA"}
                                          className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="submit"
                                          variant="success"
                                          disabled={!allFieldsFilled}
                                          onClick={() =>
                                            handleEditSaveClick(
                                              idx,
                                              fieldItem.id,
                                              "dropdown-stepper"
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            {field.type === "heading-img-dropDown-tab" && (
                              <div className="p-2 d-flex  justify-content-between align-items-center mb-3">
                                {" "}
                                <h4 className="me-3">{field.content}</h4>{" "}
                                {field.img && (
                                  <img
                                    src={Search}
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      appendPharmacy({ field1: "" })
                                    }
                                  />
                                )}{" "}
                              </div>
                            )}{" "}
                            {field.type === "heading-img-dropDown-tab" &&
                              fieldsPharmacy?.map((fieldItem, idx) => {
                                const isPharmacyDropdown =
                                  openTabDropdown[fieldItem.id] !== undefined
                                    ? openTabDropdown[fieldItem.id]
                                    : true;
                                const allFieldsFilled = watch(
                                  `DropdownFieldsPharmacy.${idx}.value`
                                );

                                return (
                                  <div
                                    key={fieldItem.id}
                                    className="p-3 mb-3 border rounded bg-light d-flex flex-column"
                                  >
                                    {" "}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        width: "100%",
                                      }}
                                    >
                                      {" "}
                                      <img
                                        src={
                                          isPharmacyDropdown
                                            ? accordionOpen
                                            : dropdownICon
                                        }
                                        onClick={() =>
                                          toggleContainerTabDropdown(
                                            fieldItem.id
                                          )
                                        }
                                        alt="dropdown-icon"
                                      />{" "}
                                    </div>{" "}
                                    <div className="col-lg-12 col-xl-12 col-md-12 mt-1">
                                      {" "}
                                      <CommonDropdown
                                        name={`DropdownFieldsPharmacy.${idx}.value`}
                                        options={tabPharmacyOption}
                                        control={control}
                                        errors={errors}
                                        register={register}
                                        validationFn={validateField}
                                        placeholder={"..."}
                                        style={{ zIndex: 1050 }}
                                        className="child-dropdown"
                                        errorStyle={false}
                                        formatOptions={true}
                                        disabled={!isPharmacyDropdown}
                                      />{" "}
                                    </div>{" "}
                                    {isPharmacyDropdown && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                          width: "100%",
                                          marginTop: "10px",
                                        }}
                                      >
                                        {" "}
                                        <CommonButton
                                          label={t("text_rmve")?.toUpperCase()}
                                          className={`btn btn-cancel mt-3 input-style-common btn-cancel-style btn-padding primary-text-color ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="button"
                                          variant="cancel"
                                          onClick={() =>
                                            handleRemoveData(idx, "pharmacyTab")
                                          }
                                        />{" "}
                                        <CommonButton
                                          label={"SALVA"}
                                          className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="submit"
                                          variant="success"
                                          disabled={!allFieldsFilled}
                                          onClick={() =>
                                            handleEditSaveClick(
                                              idx,
                                              fieldItem.id,
                                              "dropdown-tab"
                                            )
                                          }
                                        />{" "}
                                      </div>
                                    )}{" "}
                                  </div>
                                );
                              })}
                            {/* calender start here */}
                            {/*  */}
                            {field.type === "calender-field" &&
                              field.modalEdit != true && (
                                <div className="d-flex  justify-content-between align-items-center mb-3">
                                  <h4 className="me-3">{field.content}</h4>
                                  {field.img && (
                                    <img
                                      src={Search}
                                      alt=""
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        appendCalender({
                                          startDate: null,
                                          endDate: null,
                                          times: Array(7).fill({
                                            startTime: null,
                                            endTime: null,
                                          }),
                                        });
                                        if (calenderRef.current) {
                                          calenderRef?.current?.hide();
                                        }
                                      }}
                                    />
                                  )}
                                </div>
                              )}
                            {field.type === "calender-field" &&
                              fieldsCalender.map((fieldItem, idx) => {
                                const isCalenderOpen =
                                  openCalender[fieldItem.id] !== undefined
                                    ? openCalender[fieldItem.id]
                                    : true;
                                const allFieldsFilled =
                                  watch(`calenderList.${idx}.startDate`) &&
                                  watch(`calenderList.${idx}.endDate`);

                                let startDate = getValues(`calenderList.${idx}.startDate`);
                                let minEndDate = new Date()
                                if (startDate) {
                                  minEndDate = new Date(startDate);
                                  minEndDate.setDate(minEndDate?.getDate() + 1);
                                }


                                let endDate = getValues(`calenderList.${idx}.endDate`);
                                let maxDate = new Date()
                                if (endDate) {
                                  maxDate = new Date(endDate);
                                  maxDate.setDate(maxDate?.getDate() - 1);
                                }
                                return (
                                  <div
                                    key={fieldItem.id}
                                    className="bg-light d-flex flex-column "
                                    style={{
                                      alignItems: "flex-start",
                                      width: "100%",
                                      marginTop: "20px",
                                      borderBottom: "2px solid #e2e3eb",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        gap: 10,
                                        padding: 5,
                                      }}
                                      className="input-box mt-5"
                                    >
                                      {isCalenderOpen && (
                                        <div
                                          className="calender-component"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 5,
                                            backgroundColor: "white",
                                            borderRadius: "25px",
                                          }}
                                        >
                                          <label
                                            htmlFor={`calenderList.${idx}.startDate`}
                                            className="calender-label"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {t("text_valid_from")}
                                          </label>
                                          <Calendar
                                            id={`calenderList.${idx}.startDate`}
                                            value={getValues(
                                              `calenderList.${idx}.startDate`
                                            )}
                                            onChange={(e) =>
                                              handleCalendarChange(
                                                e,
                                                idx,
                                                "startDate"
                                              )
                                            }
                                            placeholder="gg/mm/aaaa"
                                            dateFormat="dd/mm/yy"
                                            className="datepicker-input"
                                            style={{ width: "120px" }}
                                            // disabled={!isCalenderOpen}
                                            maxDate={maxDate || null}
                                          />
                                        </div>
                                      )}
                                      {isCalenderOpen && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 5,
                                            backgroundColor: "white",
                                            borderRadius: "25px",
                                          }}
                                        >
                                          <label
                                            htmlFor={`calenderList.${idx}.endDate`}
                                            className="calender-label"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            {t("text_valid_to")}
                                          </label>
                                          <Calendar
                                            id={`calenderList.${idx}.endDate`}
                                            value={getValues(
                                              `calenderList.${idx}.endDate`
                                            )}
                                            onChange={(e) =>
                                              handleCalendarChange(
                                                e,
                                                idx,
                                                "endDate"
                                              )
                                            }
                                            placeholder="gg/mm/aaaa"
                                            dateFormat="dd/mm/yy"
                                            className="datepicker-input"
                                            style={{ width: "120px" }}
                                            // disabled={!isCalenderOpen}
                                            minDate={minEndDate || null}
                                          />
                                        </div>
                                      )}
                                      <div
                                        onClick={() =>
                                          toggleContainer(fieldItem.id)
                                        }
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          cursor: "pointer",
                                          marginLeft: "auto",
                                        }}
                                      >
                                        <img
                                          src={
                                            isCalenderOpen
                                              ? accordionOpen
                                              : dropdownICon
                                          }
                                          alt="dropdown-icon"
                                          width={20}
                                          height={20}
                                          onClick={() =>
                                            toggleContainerCalender(
                                              fieldItem.id
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    {/* */}
                                    {isCalenderOpen && (
                                      <div className="d-flex justify-content-between my-2 calender-field">
                                        {[
                                          "Lun",
                                          "Mar",
                                          "Mer",
                                          "Gio",
                                          "Ven",
                                          "Sab",
                                          "Dom",
                                        ].map((day, dayIdx) => {
                                          return (
                                            <>
                                              <div
                                                className="w-25 mx-2 days-label"
                                                key={dayIdx}
                                              >
                                                <div className="month-label">
                                                  {day}
                                                </div>

                                                {/* Start Time */}
                                                <Controller
                                                  name={`calenderList.${idx}.times.${dayIdx}.startTime`}
                                                  control={control}
                                                  render={({ field }) => {
                                                    return (
                                                      <Calendar
                                                        {...field}
                                                        value={
                                                          field.value || null
                                                        }
                                                        onChange={(e) =>
                                                          handleTimeChange(
                                                            e,
                                                            idx,
                                                            "startTime",
                                                            dayIdx
                                                          )
                                                        }
                                                        timeOnly
                                                        hourFormat="24"
                                                        placeholder="hh:mm"
                                                        className="start-label rounded-top center-placeholder"
                                                        ref={calenderRef}

                                                      />
                                                    );
                                                  }}
                                                />

                                                <Controller
                                                  name={`calenderList.${idx}.times.${dayIdx}.endTime`}
                                                  control={control}
                                                  render={({ field }) => (
                                                    <Calendar
                                                      {...field}
                                                      value={
                                                        field.value || null
                                                      }
                                                      onChange={(e) =>
                                                        handleTimeChange(
                                                          e,
                                                          idx,
                                                          "endTime",
                                                          dayIdx
                                                        )
                                                      }
                                                      timeOnly
                                                      hourFormat="24"
                                                      placeholder="hh:mm"
                                                      className="mt-2 end-label rounded-bottom center-placeholder"
                                                      ref={calenderRef}

                                                    />
                                                  )}
                                                />
                                              </div>
                                            </>
                                          );
                                        })}
                                      </div>
                                    )}

                                    {!isCalenderOpen && (
                                      <div style={{ width: "auto" }}>
                                        {" "}
                                        {getValues("calenderList")?.map(
                                          (obj, i) => {
                                            if (i === idx) {
                                              return (
                                                <>
                                                  {obj.startDate != null &&
                                                    obj.endDate != null ? (
                                                    <p className="fs-5">{`Valido dal ${formatDate(
                                                      obj.startDate
                                                    )} al ${formatDate(
                                                      obj.endDate
                                                    )}`}</p>
                                                  ) : obj.startDate != null ? (
                                                    <p className="fs-5">{`Valido dal ${formatDate(
                                                      obj.startDate
                                                    )} al -`}</p>
                                                  ) : obj.endDate?.length ? (
                                                    <p className="fs-5">{`Valido dal - al ${formatDate(
                                                      obj.endDate
                                                    )}`}</p>
                                                  ) : (
                                                    <p className="fs-5">{`Valido dal - al -`}</p>
                                                  )}
                                                </>
                                              );
                                            } else {
                                              return <></>;
                                            }
                                          }
                                        )}
                                      </div>
                                    )}

                                    {isCalenderOpen && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "10px",
                                          width: "100%",
                                          marginTop: "10px",
                                        }}
                                        className="mb-4"
                                      >
                                        <CommonButton
                                          label={t("text_rmve")?.toUpperCase()}
                                          className={`btn btn-cancel mt-3 input-style-common btn-cancel-style btn-padding primary-text-color ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="button"
                                          variant="cancel"
                                          // onClick={() => removeCalender(idx)}
                                          onClick={() =>
                                            handleRemoveData(
                                              idx,
                                              "calendar-stepper"
                                            )
                                          }
                                        />

                                        <CommonButton
                                          label={t("text_button_save")}
                                          className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl"
                                            ? "btn-width-xl"
                                            : "btn-width"
                                            }`}
                                          type="submit"
                                          variant="success"
                                          disabled={!allFieldsFilled}
                                          onClick={() =>
                                            handleEditSaveClick(
                                              idx,
                                              fieldItem.id,
                                              "calender-stepper"
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                    {/* <button type="button" onClick={() => removeCalender(idx)}>Remove</button> */}
                                  </div>
                                );
                              })}
                            {field.type === "heading-img-dropDown-tab" && (
                              <div className="btn-text-align ms-1">
                                {/* <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${
                                    size === "xl" ? "btn-width-xl" : "btn-width"
                                  } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                /> */}
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleRemain}
                                  disabled={Object.keys(editdropdownVale)?.length == 0 ? true : false}
                                />
                              </div>
                            )}
                            {field.type === "heading" && (
                              <p
                                className={
                                  field.style == true
                                    ? "mt-6 text-dark font-align-weight ms-2 fs-6"
                                    : "mt-2 text-dark font-align-weight ms-2 fs-6" ||
                                      field.contactStyle == true
                                      ? "mt-4 text-dark font-align-weight ms-2 fs-6"
                                      : ""
                                }
                              >
                                {field.content}
                              </p>
                            )}
                          </>
                        )
                      )}
                    </div>
                  </div>
                  <div className="button-container mt-4">
                    {roleBasedSteps?.[currentStep - 1]?.fields?.map(
                      (field, index) => {
                        const allFieldsFilled = watch(`calenderList`)?.find(
                          (ele) =>
                            console.log(
                              "Asdasd",
                              Object.values(ele).includes(null)
                            )
                        );
                        let data = getValues("calenderList");
                        return (
                          <>
                            {field.type === "buttonsRow" && (

                              <div className={`d-flex ${!field.previousBtn ? 'justify-content-between' : "justify-content-end"} align-items-center btn-text-align ms-1`}>
                                {!field.previousBtn && <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />}
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  disabled={
                                    menuRoleId?.[0] == 5 &&
                                      (getValues("hospitalAdministratorName")?.length === 0
                                        || typeof getValues("hospitalAdministratorName") != "number")
                                      ? true
                                      : menuRoleId?.[0] == 6 &&
                                        (getValues("hospitalAdministratorName")?.length === 0
                                          || typeof getValues("hospitalAdministratorName") != "number")
                                        ? true
                                        : menuRoleId?.[0] == 4 &&
                                          (getValues("hospitalPharamacyName")
                                            ?.length === 0 || typeof getValues("hospitalPharamacyName") != "number")
                                          ? true
                                          : menuRoleId?.[0] == 8 &&
                                            selectedValuesChip
                                              ?.length === 0
                                            ? true
                                            : menuRoleId?.[0] == 9 &&
                                              (getValues("hospitalPharamacyName")
                                                ?.length === 0 || typeof getValues("hospitalPharamacyName") != "number")
                                              ? true
                                              : dropdownOptions?.length === 0 ? true
                                                : menuRoleId?.[0] == 11 &&
                                                  (getValues("hospitalPharamacyName")
                                                    ?.length === 0 || typeof getValues("hospitalPharamacyName") != "number")
                                                  ? true
                                                  : false
                                  }
                                  onClick={handleRemain}
                                />
                              </div>
                            )}
                            {field.type === "heading-img-drodown" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleRemain}

                                // disabled={getValues("ContactAll")}
                                />
                              </div>
                            )}
                            {field.type === "calender-field" && (
                              <div
                                className={
                                  field.previousBtn == false
                                    ? "btn-text-align"
                                    : "d-flex justify-content-between align-items-center btn-text-align ms-1"
                                }
                              >
                                {field.previousBtn == true && (
                                  <CommonButton
                                    label={"Precedente"}
                                    className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${size === "xl"
                                      ? "btn-width-xl"
                                      : "btn-width"
                                      } btn-padding primary-text-color`}
                                    type="button"
                                    variant="cancel"
                                    onClick={handlePrevious}
                                  />
                                )}
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleRemain}
                                  // disabled={!isDisabledCalendar}
                                  disabled={calendarData?.length == 0}

                                // disabled={getValues("ContactAll")}

                                // disabled={getValues("ContactAll")}
                                />
                              </div>
                            )}

                            {field.type === "buttonsRow1" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  disabled={field.disabled}
                                  onClick={handlePrevious}
                                />

                                <CommonButton
                                  label={"Conferma"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={field.disabled}
                                  onClick={handleRemain}

                                />
                              </div>
                            )}
                            {field.type === "heading-img" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleRemain}
                                  disabled={
                                    savedData?.length === 0 ? true : false
                                  }
                                // disabled={getValues("ContactAll")}
                                />
                              </div>
                            )}

                            {field.type === "heading-img-dropdown" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />
                                <CommonButton
                                  label={"Conferma"}
                                  className={`btn btn-success mt-3 input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleRemain}
                                  disabled={
                                    pharmacyIdsData?.length ==
                                    0
                                  }
                                // disabled={getValues("ContactAll")}
                                />
                              </div>
                            )}

                            {field.type === "button" && (
                              <div className="btn-text-align">
                                <CommonButton
                                  label={field.label}
                                  disabled={field.disabled}
                                  className={`btn btn-success mt-3  input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  // onClick={handleRemain}
                                  onClick={() => {
                                    handleRemain();
                                    if (roleId == 8 && menuRoleId?.[0] == 9) {
                                      pharmacySupervisorOptionFn();
                                    }
                                  }}
                                // buttonModalXl={size==='xl' ? true : false}
                                />
                              </div>
                            )}
                            {field.type === "buttonCheck" && (
                              <div className="btn-text-align">
                                <CommonButton
                                  label={field.label}
                                  disabled={field.disabled}
                                  className={`btn btn-success mt-3  input-style-common text-white btn-padding ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleNext}
                                // buttonModalXl={size==='xl' ? true : false}
                                />
                              </div>
                            )}
                            {/* {field.type === "buttonCheck" && (
                              <div className="btn-text-align">
                                <CommonButton
                                  label={field.label}
                                  disabled={field.disabled}
                                  className={`btn btn-success mt-3  input-style-common text-white btn-padding ${
                                    size === "xl" ? "btn-width-xl" : "btn-width"
                                  }`}
                                  type="submit"
                                  variant="success"
                                  onClick={handleNextClick}
                                  // buttonModalXl={size==='xl' ? true : false}
                                />
                              </div>
                            )} */}
                            {field.type === "buttonRowEmail" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />

                                <CommonButton
                                  label={"Conferma"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={
                                    getValues("UserEmail")?.length == 0 ||
                                    getValues("UserPassword")?.length == 0
                                  }
                                  onClick={handleRemain}
                                />
                              </div>
                            )}

                            {field.type === "buttonsRowConfirm" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className={`btn btn-cancel mt-3 input-style-common btn-cancel-style  ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } btn-padding primary-text-color`}
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />
                                <CommonButton
                                  label={"Conferma"}
                                  // className={`btn btn-success mt-3 btn-width input-style-common text-white btn-padding `}
                                  className={`btn btn-success mt-3 input-style-common ${size === "xl" ? "btn-width-xl" : "btn-width"
                                    } text-white btn-padding ms-auto`}
                                  type="submit"
                                  variant="success"
                                  disabled={
                                    getValues("UserEmail")?.length == 0 ||
                                    getValues("UserPassword")?.length == 0
                                  }
                                  onClick={handleRemain}
                                />
                              </div>
                            )}

                            {field.type === "buttonRowPickup" && (
                              <div className="d-flex justify-content-between btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />
                                {/**/}

                                <CommonButton
                                  label={"Conferma"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={(() => {
                                    const pickupData = getValues("pickupData");
                                    const homeDeliveryName =
                                      getValues("homeDeliveryName");
                                    const hospitalPharmacyName = getValues(
                                      "hospitalPharamacyName"
                                    );

                                    if (pickupData === "Pickup") {
                                      return false;
                                    }
                                    if (
                                      pickupData === "Home Delivery" &&
                                      !homeDeliveryName
                                    ) {
                                      return true;
                                    }
                                    if (
                                      pickupData === "In Pharmacy" &&
                                      !hospitalPharmacyName
                                    ) {
                                      return true;
                                    }

                                    return false;
                                  })()}
                                  //  disabled={errors.UserEmail?.length>0 && errors.UserPassword?.length>0 && errors.UserConfirmPassword?.length>0}
                                  onClick={handleRemain}
                                />
                              </div>
                            )}
                            {field.type === "buttonRowSummary" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />

                                <CommonButton
                                  label={"Attiva"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={getValues('pickupData') === undefined ? true : false}

                                  onClick={handleRemain}
                                />
                              </div>
                            )}
                            {field.type === "buttonRowMsg" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 input-style-common btn-cancel-style btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />

                                <CommonButton
                                  label={"Conferma"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={
                                    getValues("remainderMsg") === undefined ||
                                      getValues("remainderMsg")?.length == 0
                                      ? true
                                      : false
                                  }
                                  onClick={handleRemain}
                                />
                              </div>
                            )}

                            {field.type === "buttonRowConsent" && (
                              <div className="d-flex justify-content-between align-items-center btn-text-align ms-1">
                                <CommonButton
                                  label={"Precedente"}
                                  className="btn btn-cancel mt-3 btn-cancel-style input-style-common btn-width btn-padding primary-text-color"
                                  type="button"
                                  variant="cancel"
                                  onClick={handlePrevious}
                                />

                                <CommonButton
                                  label={"Conferma"}
                                  className="btn btn-success mt-3 btn-width input-style-common text-white btn-padding"
                                  type="submit"
                                  variant="success"
                                  disabled={!getValues("consent")?.includes("Accettazione delle Condizioni d'uso")}

                                  onClick={handleRemain}
                                />
                              </div>
                            )}
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
            </div>

            {isSuccess != true && (
              <div className="modal-footer p-3 ms-4 ">
                {errors.FirstName ? (
                  <div className="p-error">{errors.FirstName.message}</div>
                ) : errors.LastName ? (
                  <div className="p-error ">{errors.LastName.message}</div>
                ) : errors.PhoneNumber ? (
                  <div className="p-error">{errors.PhoneNumber.message}</div>
                ) : errors.UserEmail ? (
                  <div className="p-error">{errors.UserEmail.message}</div>
                ) : errors.UserPassword ? (
                  <div className="p-error">{errors.UserPassword.message}</div>
                ) : errors.UserConfirmPassword ? (
                  <div className="p-error">
                    {errors.UserConfirmPassword.message}
                  </div>
                ) : errors?.fiscalCode ? (
                  <div className="p-error">{errors.fiscalCode.message}</div>
                ) : errors?.FiscalCode ? (
                  <div className="p-error">{errors.FiscalCode.message}</div>
                ) :
                  errors?.City ? (
                    <div className="p-error">{errors.City.message}</div>
                  ) : errors?.Denominazione ? (
                    <div className="p-error">{errors.Denominazione.message}</div>
                  ) : errors?.address ? (
                    <div className="p-error">{errors.address.message}</div>
                  ) : errors?.Province ? (
                    <div className="p-error">{errors.Province.message}</div>
                  ) : errors?.cap ? (
                    <div className="p-error">{errors?.cap?.message}</div>
                  ) :
                    errors?.Address ? (
                      <div className="p-error">{errors.Address.message}</div>
                    ) : errors?.Nome ? (
                      <div className="p-error">{errors.Nome.message}</div>
                    ) : errors?.Cognome ? (
                      <div className="p-error">{errors.Cognome.message}</div>
                    ) : errors?.Ruolo ? (
                      <div className="p-error">{errors.Ruolo.message}</div>
                    ) : errors.ministerialId ? (
                      <div className="p-error">{errors.ministerialId.message}</div>
                    ) : errors?.vat ? (
                      <div className="p-error">{errors.vat.message}</div>
                    ) : roleBasedSteps?.[currentStep - 1]?.textFooter &&
                      isEmpty(errors) ? (
                      <p className="p-1 w-20 fs-6">
                        {roleBasedSteps?.[currentStep - 1]?.textFooter}
                      </p>
                    ) : (
                      ""
                    )}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
//
export default StepperModal;
